module.exports = __webpack_public_path__ + "assets/img/index-company2.3e2d9a00.jpg";